import moment from 'moment';

interface Props {
  address: string;
  results: any;
}

const DigitalWalletInfo: (props: Props) => JSX.Element = (props: Props) => {
  const balance = (
    Math.round(
      (+props?.results?.total_incoming_value_usd - +props?.results?.total_outgoing_value_usd) * 100,
    ) / 100
  ).toFixed(2);
  const defineRiskLevel = (level: number) => {
    let labelText;
    let labelClass;

    switch (level) {
      case 0:
        labelText = 'No Risk';
        labelClass = 'badge-color-very-low';
        break;
      case 1:
        labelText = 'Info';
        labelClass = 'badge-color-low';
        break;
      case 2:
        labelText = 'Caution';
        labelClass = 'badge-color-medium';
        break;
      case 3:
        labelText = 'Medium';
        labelClass = 'badge-color-high';
        break;
      case 4:
        labelText = 'High';
        labelClass = 'badge-color-very-high';
        break;
      case 5:
        labelText = 'Critical';
        labelClass = 'badge-color-exact';
        break;
      default:
        labelText = '';
        labelClass = '';
    }

    return {
      labelText,
      labelClass,
    };
  };

  return (
    <div className="wallet-info card p-0">
      <div className="wallet-info__header d-flex justify-content-between align-items-center border-bottom">
        <div className="d-flex align-items-center">
          <span className="color-monoIntense fs-16">
            {props.address &&
              !props.results &&
              `${props.address.slice(0, 5)}....${props.address.slice(-7)}`}
            {props.results &&
              `${props.results.identifier.slice(0, 5)}....${props.results.identifier.slice(-7)}`}
          </span>
          <img className="icon" src={require('src/assets/images/icons/copy.svg').default} alt="" />
        </div>
        {props.results && (
          <div
            className={`badge badge-pill badge-risk text-white py-1 px-3 cursor-pointer ${
              defineRiskLevel(props.results.risk_level).labelClass
            }`}
          >
            {defineRiskLevel(props.results.risk_level).labelText}
          </div>
        )}
      </div>
      <div className="wallet-info__content">
        <ul>
          <li className="d-flex justify-content-between align-items-center">
            <span className="color-monoNormal fs-12">Category</span>
            <span className="color-monoIntense fs-13">{props?.results?.tag_type_verbose}</span>
          </li>
          <li className="d-flex justify-content-between align-items-center">
            <span className="color-monoNormal fs-12">Sub-Category</span>
            <span className="color-monoIntense fs-13">{props?.results?.tag_subtype_verbose}</span>
          </li>
          <li className="d-flex justify-content-between align-items-center">
            <span className="color-monoNormal fs-12">Owner</span>
            <span className="color-monoIntense fs-13">{props?.results?.currency_verbose}</span>
          </li>
          <li className="d-flex justify-content-between align-items-center">
            <span className="color-monoNormal fs-12">No. of Digital Assets</span>
            <span className="color-monoIntense fs-13">
              {props?.results?.digital_assets?.length}
            </span>
          </li>
          <li className="d-flex justify-content-between align-items-center">
            <span className="color-monoNormal fs-12">Primary Digital Asset</span>
            <span className="color-monoIntense fs-13">
              {props?.results?.digital_assets?.length && props.results.digital_assets[0].token}
            </span>
          </li>
          <li className="d-flex justify-content-between align-items-center">
            <span className="color-monoNormal fs-12">Balance</span>
            <span className="color-monoIntense fs-13">{props.results && `${balance} USD`}</span>
          </li>
          <li className="d-flex justify-content-between align-items-center">
            <span className="color-monoNormal fs-12">First Transaction</span>
            <span className="color-monoIntense fs-13">
              {moment(props?.results?.earliest_transaction_time).format('DD/MM/YYYY')}
            </span>
          </li>
          <li className="d-flex justify-content-between align-items-center">
            <span className="color-monoNormal fs-12">Latest Transaction</span>
            <span className="color-monoIntense fs-13">
              {moment(props?.results?.latest_transaction_time).format('DD/MM/YYYY')}
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DigitalWalletInfo;
